import React,{useEffect, useRef} from 'react'
import AccountLayout from '../../../../../layout/components/AccountLayout'
import { useState } from 'react'
import TransactionCategoryForm from '../components/TransectionCategoryForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';



const CellActions = (props) =>{
    return(
        <>
            <TransactionCategoryForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function TransactionCategoryDashboard() {

  const {getMasterLabel} = useAppData()
  const {transactionCategoryList,getTransactionCategoryList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"title",headerName: "Title",width:250},
        {field:"head",headerName: "Head",width:250},
       
        
        
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getTransactionCategoryList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <AccountLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Transaction Category</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><TransactionCategoryForm callBack={getTransactionCategoryList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={transactionCategoryList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getTransactionCategoryList}
              />
            </div>
          </div>
        </div>
    </AccountLayout>
    
  )
}

export default TransactionCategoryDashboard